import React from 'react';
import { FilePlus, Upload } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { useLocale } from '../contexts/LocaleContext';

interface AddDocumentMenuProps {
  onCreate: () => void;
  onImport: () => void;
  isImporting?: boolean;
  trigger: React.ReactElement;
}

export const AddDocumentMenu: React.FC<AddDocumentMenuProps> = ({
  onCreate,
  onImport,
  isImporting = false,
  trigger,
}) => {
  const { t } = useLocale();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={(event) => {
            event.stopPropagation();
            onCreate();
          }}
        >
          <FilePlus className="mr-2 h-4 w-4" />
          {t('new document')}
        </DropdownMenuItem>
        <DropdownMenuItem
          disabled={isImporting}
          onClick={(event) => {
            event.stopPropagation();
            onImport();
          }}
        >
          <Upload className="mr-2 h-4 w-4" />
          {isImporting ? t('importing') : t('import_document')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
